import { StyleSheet, Platform, useWindowDimensions } from 'react-native'
import { pageContainerStyle } from '../../common.style'
import { useMemo } from 'react'
import { useResponsive } from '../../hooks';

export const useDemandeAbsenceStyles = () => {
  const { width } = useWindowDimensions();
  const isWeb = Platform.OS === 'web';
  const isTablet = width > 768;
  const tabletScale = 1.5;
  const isResponsive = useResponsive();

const styles = useMemo(() => StyleSheet.create({
  container: {
    ...pageContainerStyle,
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingTop: 20,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1f2937',
    textAlign: 'center',
    marginBottom: 8,
  },
  pageSubtitle: {
    fontSize: 16,
    color: '#6b7280',
    textAlign: 'center',
    marginBottom: 24,
  },
  yearSelector: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    paddingHorizontal: 20,
  },
  yearText: {
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center',
    fontWeight: '500',
    marginHorizontal: 16,
  },
  yearArrow: {
    padding: 12,
    borderRadius: 8,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 16,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 2,
      },
      android: {
        elevation: 1,
      },
      web: {
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      },
    }),
  },
  contentContainer: {
    flex: 1,
  },
  scrollContainer: {
    flex: 1,
  },
  cardContainer: {
    backgroundColor: 'white',
    borderRadius: 12,
    marginBottom: 16,
    elevation: 2,
    borderWidth: 1,
    ...(isWeb && isTablet ? { flex: 1 } : {}),
    margin: 4,
    borderColor: '#e0e0e0',
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
      web: {
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      },
    }),
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginLeft: 12,
    flex: 1,
  },
  cardSubtitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#4b5563',
    marginLeft: 12,
    marginBottom: 8,
  },
  cardContent: {
    padding: 16,
    gap: 15,
  },
  emptyText: {
    fontSize: 14,
    color: '#9ca3af',
    textAlign: 'center',
    fontStyle: 'italic',
    paddingVertical: 20,
  },
  demandeItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 6,
    paddingHorizontal: 16,
    backgroundColor: '#f9fafb',
    marginBottom: 8,
    borderLeftWidth: 4,
  },
  scrollContent: {
    width: '90%',
  },
  scrollContentContainer: {
    alignItems: 'center',
  },
  dateContainer : {
    flexDirection: 'column',
    maxWidth: '100%'
  },
  demandeDate: {
    fontSize: 14,
    color: '#374151',
    flexWrap: 'wrap'
  },
  demandeDuree: {
    fontStyle: 'italic',
    color: '#686b70',
    fontSize: 11,
  },
  animationContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 40,
  },
  animation: {
    width: 200,
    height: 200,
  },
  animationText: {
    fontSize: 18,
    fontWeight: '600',
    color: '#3b82f6',
    marginTop: 16,
  },
  demandeDetailContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  containerPart:{
   // flex: 1,
    width: '100%',
    //paddingHorizontal: 4,
    //paddingBottom: 10,
    //justifyContent: 'center',
    //alignItems: 'center',
  },
  detailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
    width: '100%',
  },
  detailLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#6b7280',
    width: '30%',
  },
  detailValue: {
    fontSize: 14,
    color: '#374151',
    width: '70%',
  },
  statusBadgePrevision: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    backgroundColor: 'grey',
    marginLeft: 20,
  },
  statusText: {
    fontSize: 12,
    fontWeight: '600',
    color: 'white',
    marginLeft: 4,
  },
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 20,
  },
  loadingText: {
    fontSize: 16,
    color: '#374151',
    marginTop: 12,
  },
  buttonsContainer: {
    paddingVertical: 24,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
  },

  buttonsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },

  buttonsColumn: {
    flexDirection: 'column',
    justifyContent: 'space-around',
    gap: 10,
  },

  buttonsGroup: {
    flexDirection: isWeb && isTablet ? 'column' : 'row',
    justifyContent: 'space-around',
    gap: 10,
  },

  buttonPrimary: {
    flex: 1,
    backgroundColor: '#3b82f6',
    paddingVertical: 10,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },

  buttonSecondary: {
    flex: 1,
    backgroundColor: '#ef4444',
    paddingVertical: 10,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },

  button: {
    padding: 10,
    borderRadius: 10,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },

  buttonSelected: {
    backgroundColor: '#3b82f6',
    padding: 10,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },

  buttonText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },

  innerContainer: {
    flexDirection: isResponsive ? 'column' : 'row' ,
  },

  piecesJointes: {
    textDecorationLine: 'underline'
  },

  validationCard: {
    flexDirection: isWeb && isTablet ? 'row' : 'column',
    alignItems: 'center',
    padding: 16,
    gap: 30,
  },

  validationCommentaire : {
    flex: 1,
    borderWidth: 1,
    borderRadius: 5,
    padding: 5,
    borderColor: '#c5c7cb',
  },

  separation: {
    width: isWeb && isTablet ? 1 : '90%',
    height: isWeb && isTablet ? '90%' : 1,
    backgroundColor: 'black'
  },

  dotationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    marginTop: 12,
  },

  dotationItem: {
    alignItems: 'center',
  },

  dotationReste: {
    justifyContent: 'center',
    flexDirection: 'row',
  },

  dotationValue: {
    fontSize: 16 * (isTablet ? tabletScale : 1),
    fontWeight: 'bold',
    color: '#3b82f6',
  },

  dotationLabel: {
    fontSize: 12 * (isTablet ? tabletScale : 1),
    color: '#6b7280',
    marginTop: 2,
  },

  dotationResteValue: {
    fontSize: 26 * (isTablet ? tabletScale : 1),
    fontWeight: 'bold',
    color: '#3b82f6',
  },

  dotationResteLabel : {
    fontSize: 22 * (isTablet ? tabletScale : 1),
    color: '#6b7280',
    marginTop: 2,
  },
  droitsButton: {
    padding: 12,
    borderRadius: 8,
  },
}), [isWeb, isTablet, isResponsive]);

  return { styles, isWeb, isTablet };
};
